import { RichTextHighlightsSection } from './RichTextHighlightsSection';
export { RichTextHighlightsSection };
